import { Component, HostListener, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'app-hero',
  template: `
<section *ngIf="isMediaExtraSmall" class="hero container-fluid" [style.background-image]="backgroundImage">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2 [innerHtml]="pageTitle"></h2>
      </div>
    </div>
  </div>
</section>
`
})
export class HeroComponent implements OnInit {
  @Input()
  heroImage: any;
  @Input()
  pageTitle: string;

  backgroundImage: SafeStyle;
  isMediaExtraSmall: boolean;

  constructor(private domSanitizer: DomSanitizer) {
    this.evaluateMediaWidth();
  }

  ngOnInit(): void {
    this.backgroundImage = this.domSanitizer.bypassSecurityTrustStyle(`url(assets/img/${this.heroImage}.jpg)`);
  }

  @HostListener('window:resize')
  private evaluateMediaWidth(): void {
    this.isMediaExtraSmall = window.innerWidth < 576;
  }
}



// WEBPACK FOOTER //
// ./src/app/global/hero.component.ts